module.exports = __webpack_public_path__ + "static/media/zal.4fa2b23d.png";